import React, { useEffect, useState } from 'react'
import PageHeader from '../../Components/PageHeader'
import { useParams } from 'react-router-dom'
import showToast from '../../helpers/show_toast';
import { postSubmitForm } from '../../helpers/forms_helper';
import DOMPurify from 'dompurify';
import moment from 'moment';
import { Col, Row, } from 'reactstrap';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import Loader from '../../Components/Loader';

const NewsDetails = () => {
    const params = useParams();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const id = atob(params.id);
        fetch_data(id);
    }, []);
    const [allData, setAllData] = useState();
    const [desc, setDesc] = useState();

    const fetch_data = async (id) => {
        setLoading(true)
        const payload = { id }
        // let url = process.env.VITE_APP_BASEURL + "news/getall";
        let url = "https://api.jmialumnivic.com.au/news/getBy_Id";
        const response = await postSubmitForm(url, payload)
        if (response && response.status === 1) {
            setAllData(response.data);
            const sanitizedHtmlContent = DOMPurify.sanitize(response.data.description);
            setDesc(sanitizedHtmlContent);
            setLoading(false);
        } else {
            setLoading(false);
            showToast(response.error, "error")
        }
    };
    return (
        <>
            <section className='history_of_osa'>
                <div className="about_osa_layer">
                    <PageHeader heading={allData?.title} subheading="News & Events" link="/news" />
                    <div className="about_main_container">
                        <div className="container">
                            {loading ?
                                <Loader />
                                : allData ?
                                    <>
                                        <div className="row">
                                            <div className="col-xl-5 col-lg-5 col-md-12">
                                                <div className="newsdetails_img">
                                                    <img src={allData?.image_urls[0]} alt="" />
                                                </div>
                                            </div>
                                            <div className="col-xl-7 col-md-7 col-md-12 pl-2 pt-4">
                                                <div className="aboutschool_text">
                                                    <h4 className='news_title mb-0'>{allData.title}</h4>
                                                    <small className='text-muted ' style={{ fontWeight: '600' }}>{moment(allData.news_date).format('Do MMM YY')}</small>
                                                    <h6 className='mb-4 mt-3'>{allData.short_des}</h6>
                                                    <div className="desc">
                                                        <div dangerouslySetInnerHTML={{ __html: desc }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <br /><br />
                                        {allData.image_urls.length > 1 ?
                                            <Row>
                                                <Col lg={12}>
                                                    <Carousel
                                                        showArrows={true}
                                                        showStatus={false}
                                                        showIndicators={true}
                                                        infiniteLoop={true}
                                                        autoPlay={true}
                                                        interval={5000}
                                                        transitionTime={800}
                                                        stopOnHover={false}
                                                        swipeable={true}
                                                        emulateTouch={true}
                                                        showThumbs={true}
                                                        thumbWidth={120}
                                                    // selectedItem={1}
                                                    >
                                                        {allData.image_urls.length > 1 ?
                                                            allData.image_urls.map((img, id) => (
                                                                <>
                                                                    <div key={id} className="overflow-hidden" style={{ height: '600px', width: '100%', objectFit: 'cover' }}>
                                                                        <img src={img} alt="Description 1" style={{ height: "auto" }} />
                                                                    </div>
                                                                </>
                                                            )) : ''}

                                                        {allData.image_urls.length > 1 ?
                                                            allData.image_urls.map((img, id) => (
                                                                <div>
                                                                    <img src={img} alt="Description 2" />
                                                                </div>
                                                            )) : ''}

                                                    </Carousel>
                                                </Col>
                                            </Row>
                                            : ''}
                                        {/* <LightGallery speed={500}
                                        plugins={[lgThumbnail, lgZoom, lgRotate, lgAutoplay]}
                                        pause={2000}
                                    >
                                        {allData.image_urls.length > 1 ?
                                            allData.image_urls.map((img, id) => (
                                                <>
                                                    <a
                                                        key={id}
                                                        data-src={img} className='data_card'>
                                                        <Card className='gallery_imgs'>
                                                            <center><CardImg src={img} alt={allData.title} /></center>
                                                        </Card>
                                                    </a>
                                                </>
                                            )) : ''}

                                    </LightGallery> */}
                                    </>
                                    : ''}
                        </div>

                    </div>
                </div>
            </section>

        </>
    )
}

export default NewsDetails
